import React, { useState } from 'react';
import ListItem from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListItem';
import ListItemText from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListItemText';
import ListItemIcon from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListItemIcon';
import Avatar from 'housecall-ui/dist/DesignSystem/DataDisplay/Avatar/Avatar';
import Autocomplete from 'housecall-ui/dist/DesignSystem/Inputs/AutoComplete/Autocomplete';
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import createFilterOptions from 'housecall-ui/dist/DesignSystem/Inputs/AutoComplete/createFilterOptions';
import { changeFranchisee } from '../../Resources/Franchises/FranchiseeActions';

const filter = createFilterOptions();

const useStyles = makeStyles(() => ({
  optionPaper: {
    boxShadow: 'none',
  },
}));

function FranchiseeList({ franchisees }) {
  const { optionPaper } = useStyles();
  const [open, setOpen] = useState(true);

  const textFieldV2Props = { color: 'secondary', version: 'v2', variant: 'filled' };

  const filterOptions = (allOptions, params) => {
    const { inputValue } = params;

    if (inputValue.length >= 2) {
      return filter(allOptions, params);
    } else {
      return allOptions;
    }
  };

  const franchiseeOption = (franchisee) => (
    <ListItem component="div" disabled={franchisee.suspended}>
      <ListItemIcon>
        <Avatar src={franchisee.thumb_logo_url}>
          {franchisee.thumb_logo_url ? null : franchisee.company_name.slice(0, 1)}
        </Avatar>
      </ListItemIcon>
      <ListItemText primary={`${franchisee.company_name}${franchisee.suspended ? ' (Suspended)' : ''}`} />
    </ListItem>
  );

  return (
    <div>
      <Autocomplete
        open={open}
        classes={{ paper: optionPaper }}
        freeSolo
        filterOptions={filterOptions}
        options={franchisees}
        renderInput={(params) => <TextField {...params} {...textFieldV2Props} autoFocus label="Filter franchisees" />}
          getOptionLabel={(option) => option.company_name}
          getOptionDisabled={(option) => option.suspended }
          renderOption={(franchisee) => franchiseeOption(franchisee)}
        PopperComponent={(props) => props.children}
        onChange={(event, value) => {
          changeFranchisee(value);
          setOpen(false);
        }}
      />
    </div>
  );
}

export default React.memo(FranchiseeList);
